module.exports = __webpack_public_path__ + "img/23_71.4d65df00.png";